import { bootstrap, registerDI } from './app-init';

registerDI().then(di => bootstrap(di));
